"use client";

import Cookies from "js-cookie";
import { useTranslation } from "@/i18n/client";
import { showVehicleInfo } from "@/lib/utils/functions";
import { useAppDispatch, useAppSelector } from "@/lib/store";
import { updateVehicle } from "@/lib/store/reducers/vehicle";
import { updatePlpTitle } from "@/lib/store/reducers/uiState";
import { useCallback, useEffect, useMemo, useState } from "react";
import { updateBreadcrumb } from "@/lib/store/reducers/globalAssets";

const useVehicleController = ({
  heading,
  cookieKeys,
  searchParams,
  hasManualLook,
  categoryHeading,
  selectedVehicle,
  categoryBreadcrumbs,
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["common"]);
  const { vehicle } = useAppSelector((state) => state.vehicle);

  const [manual, setManual] = useState(hasManualLook);
  const [showOilBar, setShowOilBar] = useState(false);
  const [updatedTitle, setUpdatedTitle] = useState("");
  const [userVehicle, setUserVehicle] = useState(selectedVehicle);

  useEffect(() => {
    dispatch(updatePlpTitle(searchParams?.brand));
  }, []);

  const updatePageTitle = useCallback(() => {
    setUpdatedTitle(categoryHeading || heading);
    dispatch(updateBreadcrumb({ breadcrumbs: categoryBreadcrumbs }));
  }, []);

  const updateContainerClass = useCallback(() => {
    const ele = document.querySelector("#current-vehicle");
    if (ele) {
      ele.classList.remove("border-danger");
    }
  }, []);

  const removeManualSelection = useCallback(() => {
    setManual((prev) => {
      if (prev) {
        setUpdatedTitle(categoryHeading || heading);
        dispatch(updateBreadcrumb({ breadcrumbs: categoryBreadcrumbs }));
      }
      return false;
    });
  }, [dispatch]);

  const handleChangeVehicle = useCallback(() => {
    removeManualSelection();
    dispatch(updateVehicle(null));
    Cookies.remove(cookieKeys.new_vehicle);
    Cookies.remove(cookieKeys.manual_lookup);
    Cookies.remove(cookieKeys.selectedVehicle);
  }, [dispatch]);

  useEffect(() => {
    setUserVehicle(() => vehicle);
    updateContainerClass();
  }, [vehicle]);

  const vehicleDetail = useMemo(
    () => showVehicleInfo(userVehicle),
    [userVehicle],
  );

  useEffect(() => {
    if (!userVehicle?.vehicle) {
      setShowOilBar(false);
      return;
    }

    setShowOilBar(
      () =>
        location.pathname.includes("engine-oil") &&
        userVehicle?.vehicle?.hasOwnProperty("engineOilCapacity") &&
        !!userVehicle?.vehicle?.engineOilCapacity,
    );
  }, [userVehicle]);

  return {
    data: {
      t,
      manual,
      showOilBar,
      updatedTitle,
      vehicleDetail,
      userVehicle,
    },
    methods: {
      dispatch,
      updatePageTitle,
      handleChangeVehicle,
      removeManualSelection,
    },
  };
};

export default useVehicleController;
